import React from 'react';
import { TestInfoStrip, Button } from './../../../../components';
import { connect } from 'react-redux';
import { changeQuestion, submitTest } from './../../../../store/actions';
import './selectQuestion.scss';
import SubmitDialog from './../../submitDialogBox';

const IndicatorComponent = ({ title, backgroundColor, border, width }) => (
    <div  className='indicator_type' style={{ width: width, marginRight: 10, marginLeft: 10}}>
        <div 
            style={{ 
            height: 18,
            width: 18,
            borderWidth: 0.5,
            marginRight: 6,
            borderRadius: 5,
            backgroundColor, 
            border: `1px solid ${backgroundColor}`
            
            }}
        >

        </div>
        <span style={{fontSize: 12, fontWeight: '700'}}>{title}</span>
    </div>
)

class SelectedQuestions extends React.Component{
    state = {
        submitDialogOpen: false
    }

    render(){
        return(
            <div className='select_quest_compo' style={{position: 'relative'}}>
                <div className='top_compo'>
                </div>
                <div className='indicators py-3'>
                    <IndicatorComponent width={100} title="Attempted" backgroundColor={'#0DDE83'} border />
                    <IndicatorComponent width={100} title="Unattempted" backgroundColor={'#99BAFF'} />
                    <IndicatorComponent width={100} title="Marked" backgroundColor={'#FC7F5F'} />
                </div>
                <div className='my-4  pl-2' style={{ display: 'flex', maxHeight: 400, alignItems: 'center', flexDirection: 'row', flexWrap: 'wrap', overflow: 'auto',}}>
                     {
                         this.props.questions && this.props.questions.length > 0 && this.props.questions.map((data,index) => {
                            let marked, answered, bgColor='#F3F6FC', color='#F3F6FC'; 
                            let borderWidth = 0;           
                            this.props.questionsInfo.map(qi => {
                              if(data.id === qi.id) {
                                  if(qi['marked']) return marked = true;
                              }                 
                            })
                            this.props.selectedAnswers.map((sa, index) => {
                              if(data.id === sa.id) return answered = true;
                            })
                            
                            // color='#99BAFF';
                            if(marked) {            
                                bgColor = '#FC7F5F'
                                //   color = '#FC7F5F'
                            }
                            if(answered && !marked) {
                                bgColor = '#0DDE83';
                                //   color='#99BAFF'
                            }
                            console.log(marked, answered);
                            if(!answered && !marked){
                                // bgColor = '#99BAFF'; 
                            }
                            
                            // if(this.props.activeQuestion === index && !answered && !marked) {
                            //     bgColor = 'rgba(153, 186, 255, 1)'
                            // }                            

                             return(
                                 <div style={{
                                    width: 42,
                                    height: 42,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    margin: 10,
                                    borderRadius: 25,
                                    backgroundColor: bgColor,
                                    
                                 }}
                                  onClick={() =>  this.props.changeQuestion(index)}
                                 >
                                     <span style={{fontSize: 16, fontWeight: '600'}}>{index+1}</span>
                                  </div>   
                             )
                         })
                     }
                </div>
                <div
                    style={{
                        marginTop: 'auto',      
                        paddingBottom: 30,
                        borderTop: '1px solid #eee',
                        borderRadius: 16
                    }}
                >
                    <div 
                      style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                          
                      }}
                      className='px-2 py-2 mt-4'
                    >
                        <TestInfoStrip
                            width={120}
                            height={36}
                            title={`Attempted :`}
                            color={'#000'}
                            size={12}
                            fontWeight={600}
                            count={'14'}
                            bgColor='#E0F7F2'
                            /> 
                        <TestInfoStrip
                            bgColor='#DBEEFD'
                            width={120}
                            height={36}
                            title={`Un Attempted :`}
                            color={'#000'}
                            size={12}
                            fontWeight={600}
                            count={'04'}
                            />
                        <TestInfoStrip
                            width={120}
                            height={36}
                            title={`Marked :`}
                            color={'#000'}
                            size={12}
                            fontWeight={600}
                            count={'03'}
                            bgColor='#ffb8a6'
                            />

                    </div>
                    <div style={{margin: '20px 0px 10px', justifyContent :'center', alignItems :'center', display :'flex'}}>
                        <Button
                            width={180}
                            height={45}
                            bgColor={'#FF7954'}
                            bdColor={'#FF7954'}
                            title={'Submit'}
                            textStyle={{color: '#fff', fontWeight: '700', fontSize: 16}}
                            onClick={() => {
                                this.setState({
                                    submitDialogOpen: true
                                })
                            }}                           
                        />
                    </div>
                </div>
                {
                    this.state.submitDialogOpen ?
                        <SubmitDialog
                            open={this.state.submitDialogOpen}
                            handleClose={
                                () => this.setState({
                                    submitDialogOpen: false
                                })
                            }
                            handleSubmitTest={() => this.props.submitTest(false, true)}
                        />
                    : null
                }
            </div>
        )
    }
}
const mapStateToProps = state => ({
    questions: state.testInfo.test,
    questionsInfo: state.testInfo.questionsInfo,
    selectedAnswers: state.testInfo.selectedAnswers ?  state.testInfo.selectedAnswers : [],
    activeQuestion: state.testInfo && state.testInfo.activeQuestion,
})


export default connect(mapStateToProps, {changeQuestion, submitTest})(SelectedQuestions)